export const VIEW_ELEMENT = 'VIEW_ELEMENT';
export const CREATE_APPOINTMENT = 'CREATE_APPOINTMENT';
export const SIDEBAR_AGENDA = 'SIDEBAR_AGENDA';
export const SIDEBAR_NODE_AI = 'SIDEBAR_NODE_AI';

export const viewElement = (payload) => ({
  type: VIEW_ELEMENT,
  payload,
});

export const createAppointment = (payload) => ({
  type: 'CREATE_APPOINTMENT',
  payload,
});

export const sidebarAgenda = (payload) => ({
  type: 'SIDEBAR_AGENDA',
  payload,
});

export const sidebarNodeAI = (payload) => ({
  type: 'SIDEBAR_NODE_AI',
  payload,
});
